module.exports = __webpack_public_path__ + "img/capslock.2791b173.svg";